import { useState } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { QrCode, Loader2, CheckCircle } from 'lucide-react'
import { useFormularioConfig, useSolicitarCodigo } from '../../hooks/useQrCodigo'
import { DynamicForm } from '../../components/DynamicForm'

export function SolicitudPage() {
  const { uuid } = useParams<{ uuid: string }>()
  const location = useLocation()
  const codigoUsado = (location.state as { codigoUsado?: string })?.codigoUsado || ''

  const { data: config, isLoading } = useFormularioConfig(uuid)
  const solicitarMutation = useSolicitarCodigo()
  const [enviado, setEnviado] = useState(false)

  const handleSubmit = async (datos: Record<string, string>) => {
    if (!uuid) return
    try {
      await solicitarMutation.mutateAsync({ uuid, datos, codigoUsado })
      setEnviado(true)
    } catch {
      // Error handled by mutation
    }
  }

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-teal-500" />
      </div>
    )
  }

  if (enviado) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-green-50 to-white dark:from-gray-900 dark:to-gray-950 flex items-center justify-center p-4">
        <Card className="max-w-md w-full border-0 shadow-lg">
          <CardContent className="p-8 text-center space-y-6">
            <div className="rounded-full bg-green-100 dark:bg-green-900/30 p-4 w-fit mx-auto">
              <CheckCircle className="h-12 w-12 text-green-600" />
            </div>
            <div>
              <h2 className="text-xl font-bold">¡Solicitud enviada!</h2>
              <p className="text-muted-foreground text-sm mt-2">
                Su solicitud ha sido registrada exitosamente. Nos pondremos en contacto pronto.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-teal-50 to-white dark:from-gray-900 dark:to-gray-950">
      <div className="bg-gradient-to-r from-teal-600 to-teal-800 text-white py-6 px-4">
        <div className="max-w-lg mx-auto text-center">
          <QrCode className="h-10 w-10 mx-auto mb-2 opacity-80" />
          <h1 className="text-xl font-bold">Solicitar Código</h1>
          <p className="text-teal-100 mt-1 text-sm">
            Complete el formulario para solicitar un nuevo código
          </p>
        </div>
      </div>

      <div className="max-w-lg mx-auto px-4 -mt-4">
        <Card className="border-0 shadow-lg">
          <CardHeader>
            <CardTitle className="text-lg">Datos de la solicitud</CardTitle>
          </CardHeader>
          <CardContent>
            {config?.campos && config.campos.length > 0 ? (
              <DynamicForm
                campos={config.campos}
                onSubmit={handleSubmit}
                isSubmitting={solicitarMutation.isPending}
                submitLabel="Enviar solicitud"
              />
            ) : (
              <p className="text-sm text-muted-foreground text-center py-4">
                No hay formulario configurado para este libro.
              </p>
            )}
            {solicitarMutation.isError && (
              <p className="text-sm text-red-500 mt-3 text-center">
                Error al enviar solicitud. Intente nuevamente.
              </p>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
